import { object, string } from "yup";

const qaReviewSchema = object().shape({
  reviewer: string().label("Reviewer").required(),
  date: string().label("Date").required(),
  qaStatus: string().label("QA Status").required(),
});

export default qaReviewSchema;
